import { GenericModel } from "../../../generic.model";

export class OpeningHoursModel extends GenericModel {
    public begin: string;
    public end: string; //{value: "23:00:00", time: "23:00:00"}
    public group: string; // string but DropOff or Pickup
    public xDayOfWeek: string; // string but three first letter of day
    public xStatus: string;

    protected fromJson(json?: any): boolean {
        this.begin = json.begin?.value ?? null;
        this.end = json.end?.value ?? null;
        this.group = json.group ?? null;
        this.xDayOfWeek = json.xDayOfWeek ?? null;
        this.xStatus = json.xStatus ?? null;
        return this.isValid();
    }

    protected isValid(): boolean {
        return this.begin !== null && this.end !== null;
    }
}